


















/**
 * emitさせて、親コンポーネントにdata.filterQueryを渡す
 * https://www.hypertextcandy.com/vuejs-components-introduction-emit-events
 *
 * 配列にv-modelを使いたいが、keyが無いと双方向的な挙動にならない
 * https://qiita.com/clomie/items/7a69ee850a304595142e#%E9%85%8D%E5%88%97%E3%82%92%E3%83%90%E3%82%A4%E3%83%B3%E3%83%89%E3%81%99%E3%82%8B%E5%A0%B4%E5%90%88%E3%81%AEv-for%E3%81%A8%E3%81%AE%E7%B5%84%E3%81%BF%E5%90%88%E3%82%8F%E3%81%9B
 * そのため、「emitするときに、このContainerComponent独自のデータの持ち方をstoreの型にふさわしい形に修正する」ようにする
 */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  typeFilterQueryConditions,
  NSStoreEmployeeState
} from '@/store/modules/employee';
// import BaseInputCheckbox from '@/components/BaseInputCheckbox.vue';

@Component({
  components: {
    // BaseInputCheckbox
  }
})
export default class JobOfferFilterConditionForm extends Vue {
  @Prop() filters!: typeFilterQueryConditions;
  @Prop() filterQuery!: NSStoreEmployeeState.filterQuery;
  @Watch('filters') onFiltersChanged() {
    this.checkedPrefectures = this.filterQuery.prefectures;
  }
  private checkedPrefectures: string[] = [];

  emitFilterQuery() {
    /**
     * このコンポーネントがemitするときに期待されるインターフェイス
     */
    const filterQuery: NSStoreEmployeeState.filterQuery = {
      prefectures: this.checkedPrefectures
    };

    // prefecturesのインターフェイスに併せて加工する
    // filterQuery.prefectures = this.checkedValues.filter(function(value) {
    //   return typeof value === 'string';
    // }) as string[];

    console.log(filterQuery);

    this.$emit('filterQuery', filterQuery);
  }

  /**
   * NOTE 本来、子コンポーネントと配列のv-modelは無理なので、素直にやる場合は、自力でイベントを受け取って配列操作をする
   * https://qiita.com/clomie/items/7a69ee850a304595142e#%E9%85%8D%E5%88%97%E3%82%92%E3%83%90%E3%82%A4%E3%83%B3%E3%83%89%E3%81%99%E3%82%8B%E5%A0%B4%E5%90%88%E3%81%AEv-for%E3%81%A8%E3%81%AE%E7%B5%84%E3%81%BF%E5%90%88%E3%82%8F%E3%81%9B
   */
  // handleOnChange(index: number, id: string, checked: boolean) {
  //   console.log(id, checked);
  //
  //   if (checked) {
  //     this.checkedValues[index] = id;
  //   } else {
  //     this.checkedValues[index] = undefined;
  //   }
  //
  //   this.emitFilterQuery();
  // }
}
